import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import apiClient from "../../ApiClient";
import { Card, CardBody } from "../../components/card/card";
import moment from "moment";
import { Swiper, SwiperSlide } from "swiper/react";
import { AppSettings } from "../../config/app-settings";
import Fancybox from "../../components/Fancybox";

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import logo from "../../images/logo.png";
import logoWhite from "../../images/logo-white.png";

import "swiper/css/pagination";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

// const cleanHtml = (description) => {
//   if (typeof description === "string") {
//     return description.replace(/<[^>]+>/g, ""); // HTML etiketlerini kaldır
//   }
//   return description; // Eğer geçerli bir string değilse, olduğu gibi döndür
// };

export default function Gorevler() {
  const context = useContext(AppSettings);

  // Swiper
  const [imageSwipers, setImageSwipers] = useState([]);
  const [todoSwipers, setTodoSwipers] = useState([]);

  // States for data and category filtering
  const [groupedTodos, setGroupedTodos] = useState(null);
  const [filteredTodos, setFilteredTodos] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState("TÜMÜ");

  // Function to group by category
  const groupByCategory = (data) => {
    const grouped = {};
    data.forEach((item) => {
      const categoryId = item.category.id;
      if (!grouped[categoryId]) {
        grouped[categoryId] = {
          category: item.category,
          list: [],
        };
      }
      const { category, ...rest } = item;
      grouped[categoryId].list.push(rest);
    });
    // Sort list by id within each category
    Object.values(grouped).forEach((group) => {
      group.list.sort((a, b) => a.sort - b.sort);
    });
    return Object.values(grouped);
  };

  // Fetch todos data
  const todoData = useCallback(async (customer_id) => {
    setGroupedTodos(null);

    try {
      const response = await apiClient.get(
        `/todos${customer_id ? `?customer_id=${customer_id}` : ""}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (response) {
        const groupedData = groupByCategory(response.data);
        setGroupedTodos(groupedData);
        setFilteredTodos(groupedData); // Initially set filtered to show all
      }
    } catch (error) {
      console.error("TODO", error);
    }
  }, []);

  useEffect(() => {
    todoData(context?.activeCustomer);
  }, [context?.activeCustomer]);

  // Handle category click
  const handleCategoryClick = (category) => {
    if (category === "TÜMÜ") {
      setFilteredTodos(groupedTodos); // Reset to show all categories
    } else {
      const filtered = groupedTodos.filter(
        (group) => group.category.name === category
      );
      setFilteredTodos(filtered); // Show only selected category
    }
    setSelectedCategory(category); // Update selected category
  };

  // Item Return
  const [reportItem, setReportItem] = useState({ group: null }, { todo: null });
  const [showDescription, setShowDescription] = useState(false);

  function TaskItem(group, todo, print = false) {
    return (
      <Card>
        <CardBody>
          <div className="progress-wrapper d-flex align-items-center mb-2">
            <span
              className="d-block text-center fw-bold me-2 text-white"
              style={{ fontSize: 12 }}
            >
              %{todo.title.includes("#") ? todo.title.split("#")[0] : 0}
            </span>
            <div className="progress flex-1" style={{ height: 5 }}>
              <div
                className="progress-bar bg-theme"
                role="progressbar"
                style={{
                  width: `${
                    todo.title.includes("#") ? todo.title.split("#")[0] : 0
                  }%`,
                }}
                aria-valuenow={
                  todo.title.includes("#") ? todo.title.split("#")[0] : 0
                }
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
          </div>

          <h5>
            {todo.title.includes("#") ? todo.title.split("#")[1] : todo.title}
          </h5>

          <div className="mt-3 position-relative">
            {!print && todo?.image && todo?.image.length !== 0 && (
              <>
                <button
                  style={{
                    zIndex: 2,
                    transform: "translateY(-50%)",
                    borderRadius: "100%",
                    width: 32,
                    height: 32,
                  }}
                  className="btn btn-dark d-flex align-items-center justify-content-center position-absolute start-0 mx-1 top-50"
                  onClick={() => imageSwipers[todo.id]?.slidePrev()}
                >
                  <i className="fa-lg fa-fw fas fa-angle-left"></i>
                </button>
                <button
                  style={{
                    zIndex: 2,
                    transform: "translateY(-50%)",
                    borderRadius: "100%",
                    width: 32,
                    height: 32,
                  }}
                  className="btn btn-dark d-flex align-items-center justify-content-center position-absolute end-0 mx-1 top-50"
                  onClick={() => imageSwipers[todo.id]?.slideNext()}
                >
                  <i className="fa-lg fa-fw fas fa-angle-right"></i>
                </button>
              </>
            )}

            {todo?.image && todo?.image.length !== 0 ? (
              <Fancybox
                options={{
                  Carousel: {
                    infinite: false,
                  },
                }}
              >
                {print ? (
                  <div className="d-flex flex-wrap gap-3 image-row">
                    {todo?.image.map((img, imgIndex) => (
                      <a
                        href={img}
                        key={imgIndex}
                        data-fancybox={todo?.id + "-gallery"}
                      >
                        <img
                          key={imgIndex}
                          src={img}
                          alt={todo.title + "_" + imgIndex}
                          style={{ height: 400 }}
                        />
                      </a>
                    ))}
                  </div>
                ) : (
                  <Swiper
                    onSwiper={(s) => {
                      setImageSwipers((prevSwipers) => ({
                        ...prevSwipers,
                        [todo?.id]: s,
                      }));
                    }}
                    slidesPerView={1}
                  >
                    {todo?.image.map((img, imgIndex) => (
                      <SwiperSlide key={imgIndex}>
                        <a href={img} data-fancybox={todo?.id + "-gallery"}>
                          <img
                            key={imgIndex}
                            src={img}
                            alt={todo.title + "_" + imgIndex}
                            className="w-100 img-cover"
                            style={{ height: 200 }}
                          />
                        </a>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                )}
              </Fancybox>
            ) : (
              <div
                className="w-100 d-flex align-items-center justify-content-center"
                style={{ background: "#ffffff10", height: 200 }}
              >
                {context && context?.me?.customer?.settings?.logo ? (
                  <img
                    src={context?.me?.customer?.settings?.logo}
                    alt={context?.me?.customer?.customer?.name}
                    height={45}
                  />
                ) : (
                  <img
                    src={logoWhite}
                    alt={
                      window.location.host.includes("datakokpit")
                        ? "Datakokpit"
                        : "Strateji Merkezi"
                    }
                    height={20}
                  />
                )}
              </div>
            )}
          </div>

          {print
            ? todo?.description && (
                <div className="mt-3">
                  <span className="d-block">{context?.t?.description}</span>
                  <div
                    className="text-white mb-0 overflow-auto"
                    dangerouslySetInnerHTML={{
                      __html: todo?.description,
                    }}
                  />
                </div>
              )
            : todo?.description && (
                <button
                  type="button"
                  className="btn btn-outline-theme mt-2 me-2 btn-sm"
                  data-bs-toggle="modal"
                  data-bs-target="#taskDescriptionModal"
                  onClick={() => setShowDescription(todo?.description)}
                >
                  {context?.t?.aciklama_goster}
                </button>
              )}

          {print
            ? todo?.summary && (
                <div className="mt-3">
                  <span className="d-block">{context?.t?.yonetici_ozeti}</span>
                  <div
                    className="text-white mb-0 overflow-auto"
                    dangerouslySetInnerHTML={{
                      __html: todo?.summary,
                    }}
                  />
                </div>
              )
            : todo?.summary && (
                <button
                  type="button"
                  className="btn btn-outline-theme mt-2 btn-sm"
                  data-bs-toggle="modal"
                  data-bs-target="#taskDescriptionModal"
                  onClick={() => setShowDescription(todo?.summary)}
                >
                  {context?.t?.yonetici_ozeti}
                </button>
              )}

          <div className="mt-3">
            <span>{context?.t?.address}</span>
            <p className="text-white mb-0">
              {todo?.neighbourhood?.label} {todo?.street?.label}{" "}
              {todo?.building ? todo?.building[0] : ""} {todo?.independent}
              {todo?.district?.label}/{todo?.city?.label}
            </p>
          </div>

          {todo?.tags && todo?.tags.length !== 0 && (
            <div className="mt-3">
              <span className="d-block">{context?.t?.etiketler}</span>
              <div className="d-flex flex-wrap gap-1">
                {todo?.tags.map((tag, tagIndex) => (
                  <span
                    key={tagIndex}
                    className="btn gap-1 text-white fw-bold btn-sm py-0"
                    style={{
                      background: group?.category?.color,
                    }}
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          )}

          {todo?.file && (
            <div className="mt-3">
              <span className="d-block">{context?.t?.file}</span>
              <a href={todo?.file} target="_blank" rel="noopener noreferrer">
                {context?.t?.dosyayi_goruntule}
              </a>
            </div>
          )}

          <div style={{ background: "#ffffff10" }} className="px-3 py-2 mt-3">
            <div className="row align-items-center">
              <div className="col-12">
                {todo?.created_at && (
                  <span className="d-block" style={{ fontSize: 13 }}>
                    {context?.t?.olusturulma}:
                    <span className="text-white ms-2">
                      {moment(todo?.created_at).format("DD MMMM YYYY - HH:mm")}
                    </span>
                  </span>
                )}

                {todo?.updated_at && (
                  <span className="d-block" style={{ fontSize: 13 }}>
                    {context?.t?.guncelleme}:
                    <span className="text-white ms-2">
                      {moment(todo?.updated_at).format("DD MMMM YYYY - HH:mm")}
                    </span>
                  </span>
                )}
              </div>

              {todo?.user && (
                <div className="col position-relative user-info-hover border-top pt-2 mt-2">
                  <div className="pointer">
                    {todo?.user?.name}
                    {!print && <i className="fas fa-info-circle ms-2"></i>}
                  </div>

                  {print ? (
                    <div className="text-white border p-2 mt-2">
                      <div>
                        {context?.t?.role}: {todo?.user?.role?.name}
                      </div>
                      <div>
                        {context?.t?.username}: {todo?.user?.username}
                      </div>
                      <div>
                        {context?.t?.email}: {todo?.user?.email}
                      </div>
                      <div>
                        {context?.t?.phone}: {todo?.user?.phone}
                      </div>
                    </div>
                  ) : (
                    <div
                      className="position-absolute start-0 bg-black text-white border p-2 user-info-hover-item"
                      style={{
                        fontSize: 12,
                        bottom: "100%",
                      }}
                    >
                      <div>
                        {context?.t?.role}: {todo?.user?.role?.name}
                      </div>
                      <div>
                        {context?.t?.username}: {todo?.user?.username}
                      </div>
                      <div>
                        {context?.t?.email}: {todo?.user?.email}
                      </div>
                      <div>
                        {context?.t?.phone}: {todo?.user?.phone}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          {context?.me?.customer?.settings?.missionReport && !print && (
            <button
              type="button"
              className="btn btn-outline-theme mt-2 btn-sm"
              onClick={() => setReportItem({ group, todo })}
            >
              {context?.t?.rapor}
            </button>
          )}
        </CardBody>
      </Card>
    );
  }

  // Customer Logo Color
  const [, setCustomerLogo] = useState(null);
  const [, setCustomerName] = useState(null);
  const [, setCustomerColor] = useState(null);

  async function handleGetCustomer(id) {
    const customerData = await context.getCustomer(id);
    const customerTheme = customerData?.settings?.theme.split("|");

    setCustomerName(customerData?.customer?.name);
    setCustomerLogo(customerData?.settings?.logo);

    if (customerTheme && customerTheme[1] !== "null") {
      setCustomerColor(customerTheme[1]);
    } else {
      if (context.me?.customer?.settings?.theme.split("|")[1] === "null") {
        setCustomerColor(context.me?.customer?.settings?.theme.split("|")[1]);
      } else {
        setCustomerColor(context.me?.customer?.settings?.theme.split("|")[1]);
      }
    }
  }

  useEffect(() => {
    if (context?.activeCustomer) {
      handleGetCustomer(context?.activeCustomer);
    }
    // eslint-disable-next-line
  }, [context]);

  // PDF
  const [dataView] = useState(null);
  const [, setLogoData] = useState("");

  const imageToBase64 = (imagePath, type) => {
    fetch(imagePath)
      .then((response) => response.blob())
      .then((blob) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          if (type === "logo") {
            setLogoData(reader.result);
          }
        };
        reader.onerror = (error) => {
          console.error("Error reading image:", error);
        };
        reader.readAsDataURL(blob);
      })
      .catch((error) => {
        console.error("Error fetching image:", error);
      });
  };

  useEffect(() => {
    imageToBase64(logo, "logo");
  }, []);

  // function handleExportPDF() {
  //   // PDF içeriğini oluştur
  //   const pageSizeWidth = 595;
  //   const pageSizeHeight = 842;

  //   const content = groupedTodos.map((item, index) => {
  //     // Listeyi `sort` değişkenine göre sırala
  //     const sortedList = item.list.sort((a, b) => a.sort - b.sort);

  //     // Liste öğelerini işlemek
  //     const listItems = sortedList.map((listItem, listItemIndex) => {
  //       // Detayları iki sütunda göstermek için `columns` kullanıyoruz
  //       return {
  //         columns: [
  //           {
  //             width: "70%",
  //             stack: [
  //               {
  //                 text: `#${listItemIndex + 1}`,
  //                 style: "listItem",
  //               },
  //               {
  //                 text: `${context?.t?.tamamlanma_yuzdesi}:  ${
  //                   listItem.title.includes("#")
  //                     ? "%" + listItem.title.split("#")[0]
  //                     : "%0"
  //                 }`,
  //                 style: "listItem",
  //               },
  //               {
  //                 text: `${context?.t?.title}:  ${
  //                   listItem.title.includes("#")
  //                     ? listItem.title.split("#")[1]
  //                     : listItem.title
  //                 }`,
  //                 style: "listItem",
  //               },
  //               {
  //                 text: `${context?.t?.description}: ${
  //                   listItem.description ? cleanHtml(listItem.description) : "-"
  //                 }`,
  //                 style: "listItem",
  //               },
  //               {
  //                 text: `${context?.t?.yonetici_ozeti}: ${
  //                   listItem.summary ? cleanHtml(listItem.summary) : "-"
  //                 }`,
  //                 style: "listItem",
  //               },
  //               {
  //                 text: `${context?.t?.address}: ${
  //                   listItem?.neighbourhood?.label || ""
  //                 } ${listItem?.street ? listItem?.street?.label : ""}${" "} ${
  //                   listItem?.building ? listItem?.building[0] : ""
  //                 } ${listItem?.independent || ""} ${
  //                   listItem?.district?.label
  //                 }/${listItem?.city?.label}`,
  //                 style: "listItem",
  //               },
  //               {
  //                 text: `${context?.t?.olusturulma}: ${moment(
  //                   listItem.created_at
  //                 ).format("DD MMMM YYYY - HH:mm")}`,
  //                 style: "listItem",
  //               },
  //               {
  //                 text: `${context?.t?.guncelleme}: ${moment(
  //                   listItem.updated_at
  //                 ).format("DD MMMM YYYY - HH:mm")}`,
  //                 style: "listItem",
  //               },
  //             ],
  //           },
  //           {
  //             width: "30%",
  //             stack: [
  //               {
  //                 text: `${context?.t?.user}: ${listItem.user?.name}`,
  //                 style: "listItem",
  //               },
  //               {
  //                 text: `${context?.t?.username}: ${listItem.user?.username}`,
  //                 style: "listItem",
  //               },
  //               {
  //                 text: `${context?.t?.role}: ${listItem.user?.role?.name}`,
  //                 style: "listItem",
  //               },
  //               {
  //                 text: `${context?.t?.email}: ${listItem.user.email}`,
  //                 style: "listItem",
  //               },
  //               {
  //                 text: `${context?.t?.phone}: ${listItem.user.phone}`,
  //                 style: "listItem",
  //               },
  //             ],
  //           },
  //         ],
  //         margin: [0, 10, 0, 10],
  //       };
  //     });

  //     return [
  //       index > 0 ? { text: "", pageBreak: "after" } : {},
  //       {
  //         columns: [
  //           // {
  //           //   width: 80,
  //           //   image: customerLogo ? customerLogo : logoData,
  //           // },
  //           {
  //             width: "*",
  //             text: moment(new Date()).format("DD/MM/YYYY HH:mm"),
  //             alignment: "right",
  //             fontSize: 10,
  //             margin: [0, 0, 0, 10],
  //           },
  //         ],
  //         columnGap: 10,
  //       },
  //       {
  //         table: {
  //           widths: ["*"],
  //           body: [
  //             [
  //               {
  //                 style: "header",
  //                 border: [false, false, false, false],
  //                 text: item.category.name,
  //               },
  //             ],
  //           ],
  //         },
  //       },
  //       ...listItems,
  //     ];
  //   });

  //   // PDF tanımı
  //   const documentDefinition = {
  //     info: {
  //       title: context?.t?.strateji_planlari,
  //       author: customerName ? customerName : "STRATEJİ MERKEZİ",
  //       subject: context?.t?.gorevler,
  //     },
  //     pageSize: {
  //       width: pageSizeWidth,
  //       height: pageSizeHeight,
  //     },
  //     pageMargins: [10, 10, 10, 10],
  //     watermark: {
  //       text: customerName ? customerName : "STRATEJİ MERKEZİ",
  //       color: customerColor
  //         ? customerColor
  //         : window.location.host.includes("datakokpit")
  //         ? "#17248a"
  //         : "#3cd2a5",
  //       opacity: 0.1,
  //       bold: true,
  //       italics: false,
  //     },
  //     content: [...content.flat()],
  //     styles: {
  //       header: {
  //         fillColor: "#eeeeee",
  //         alignment: "center",
  //         margin: [0, 5, 0, 5],
  //         bold: true,
  //         fontSize: 12,
  //       },
  //       headerSubTitle: {
  //         fillColor: "#eeeeee",
  //         alignment: "center",
  //         bold: false,
  //         fontSize: 10,
  //         margin: [0, 0, 0, 10],
  //       },
  //       listItem: {
  //         fontSize: 10,
  //         margin: [2, 2, 2, 2],
  //       },
  //       text: {
  //         fontSize: 8,
  //       },
  //       tablo: {
  //         fontSize: 8,
  //       },
  //     },
  //   };

  //   // PDF oluştur ve indir
  //   // const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
  //   // pdfDocGenerator.getDataUrl((dataUrl) => {
  //   //   setDataView(dataUrl);
  //   // });
  //   pdfMake
  //     .createPdf(documentDefinition)
  //     .download(context?.t?.strateji_planlari + ".pdf");
  // }

  // PRINT
  const printRef = useRef();

  const handlePrint = async () => {
    if (context?.me?.customer?.settings?.missionReport) {
      const printContent = printRef.current;

      if (printContent) {
        // Tüm img etiketlerini seç
        const images = Array.from(printContent.querySelectorAll("img"));

        // Tüm resimlerin yüklendiğini kontrol et
        await Promise.all(
          images.map(
            (img) =>
              new Promise((resolve) => {
                if (img.complete) {
                  resolve(); // Zaten yüklendiyse hemen çöz
                } else {
                  img.onload = resolve; // Yüklendikten sonra çöz
                  img.onerror = resolve; // Yüklenemezse bile devam et
                }
              })
          )
        );

        const printWindow = window.open("", "_blank");
        if (printContent && printWindow) {
          printWindow.document.write(
            `
          <html>
            <head>
              <title>` +
              (window.location.host.includes("datakokpit")
                ? "Datakokpit"
                : "Strateji Merkezi") +
              `</title>
              <style>
              :root,[data-bs-theme=light] { --bs-white-rgb: 255,255,255; --bs-black-rgb: 0,0,0; --bs-font-sans-serif: system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"; --bs-font-monospace: SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace; --bs-gradient: linear-gradient(180deg,#ffffff26,#fff0); --bs-body-font-family: "Chakra Petch",sans-serif; --bs-body-font-size: 0.875rem; --bs-border-width: 1px; --bs-border-style: solid; --bs-border-color: #0003; } *,:after,:before { box-sizing: border-box } @media(prefers-reduced-motion:no-preference) { :root { scroll-behavior: smooth } } body { font-family: var(--bs-body-font-family); } hr { border: 0; border-top: 1px solid; border-top: var(--bs-border-width) solid; color: inherit; margin: 1rem 0; opacity: .25 } .h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6 { color: black; font-weight: 600; line-height: 1.2; margin-bottom: .5rem; margin-top: 0 } .h1,h1 { font-size: calc(1.34375rem + 1.125vw) } @media(min-width: 1200px) { .h1,h1 { font-size:2.1875rem } } .h2,h2 { font-size: calc(1.3rem + .6vw) } @media(min-width: 1200px) { .h2,h2 { font-size:1.75rem } } .h3,h3 { font-size: calc(1.27813rem + .3375vw) } @media(min-width: 1200px) { .h3,h3 { font-size:1.53125rem } } .h4,h4 { font-size: calc(1.25625rem + .075vw) } @media(min-width: 1200px) { .h4,h4 { font-size:1.3125rem } } .h5,h5 { font-size: 1.09375rem } .h6,h6 { font-size: .875rem } p { margin-bottom: 1rem; margin-top: 0 } x .card { --bs-card-spacer-y: 1rem; --bs-card-spacer-x: 1rem; --bs-card-title-spacer-y: 0.5rem; --bs-card-title-color: ; --bs-card-subtitle-color: ; --bs-card-border-width: var(--bs-border-width); --bs-card-border-color: var(--bs-border-color-translucent); --bs-card-border-radius: var(--bs-border-radius); --bs-card-box-shadow: ; --bs-card-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width)); --bs-card-cap-padding-y: 0.5rem; --bs-card-cap-padding-x: 1rem; --bs-card-cap-bg: rgba(var(--bs-body-color-rgb),0.03); --bs-card-cap-color: ; --bs-card-height: ; --bs-card-color: ; --bs-card-bg: #0000; --bs-card-img-overlay-padding: 1rem; --bs-card-group-margin: 10px; word-wrap: break-word; background-clip: initial; background-color: var(--bs-card-bg); border: var(--bs-card-border-width) solid var(--bs-card-border-color); border-radius: var(--bs-card-border-radius); color: #000000bf; color: var(--bs-body-color); display: flex; flex-direction: column; height: var(--bs-card-height); min-width: 0 } .card>hr { margin-left: 0; margin-right: 0 } .card>.list-group { border-bottom: inherit; border-top: inherit } .card>.list-group:first-child { border-top-left-radius: var(--bs-card-inner-border-radius); border-top-right-radius: var(--bs-card-inner-border-radius); border-top-width: 0 } .card>.list-group:last-child { border-bottom-left-radius: var(--bs-card-inner-border-radius); border-bottom-right-radius: var(--bs-card-inner-border-radius); border-bottom-width: 0 } .card>.card-header+.list-group,.card>.list-group+.card-footer { border-top: 0 } .card-body { color: #000000c4; flex: 1 1 auto; padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x) } .card-title { color: var(--bs-card-title-color); margin-bottom: var(--bs-card-title-spacer-y) } .card-subtitle { color: var(--bs-card-subtitle-color); margin-top: calc(var(--bs-card-title-spacer-y)*-.5) } .card-subtitle,.card-text:last-child { margin-bottom: 0 } .card-link+.card-link { margin-left: var(--bs-card-spacer-x) } .card-header { background-color: var(--bs-card-cap-bg); border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color); color: var(--bs-card-cap-color); margin-bottom: 0; padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x) } .card-header:first-child { border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0 } .card-footer { background-color: var(--bs-card-cap-bg); border-top: var(--bs-card-border-width) solid var(--bs-card-border-color); color: var(--bs-card-cap-color); padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x) } .card-footer:last-child { border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) } .card-header-tabs { border-bottom: 0; margin-bottom: calc(var(--bs-card-cap-padding-y)*-1); margin-left: calc(var(--bs-card-cap-padding-x)*-.5); margin-right: calc(var(--bs-card-cap-padding-x)*-.5) } .card-header-tabs .nav-link.active { background-color: var(--bs-card-bg); border-bottom-color: var(--bs-card-bg) } .card-header-pills { margin-left: calc(var(--bs-card-cap-padding-x)*-.5); margin-right: calc(var(--bs-card-cap-padding-x)*-.5) } .card-img-overlay { border-radius: var(--bs-card-inner-border-radius); bottom: 0; left: 0; padding: var(--bs-card-img-overlay-padding); position: absolute; right: 0; top: 0 } .card-img,.card-img-bottom,.card-img-top { width: 100% } .card-img,.card-img-top { border-top-left-radius: var(--bs-card-inner-border-radius); border-top-right-radius: var(--bs-card-inner-border-radius) } .card-img,.card-img-bottom { border-bottom-left-radius: var(--bs-card-inner-border-radius); border-bottom-right-radius: var(--bs-card-inner-border-radius) } .card-group>.card { margin-bottom: var(--bs-card-group-margin) } @media(min-width: 576px) { .card-group { display:flex; flex-flow: row wrap } .card-group>.card { flex: 1 0; margin-bottom: 0 } .card-group>.card+.card { border-left: 0; margin-left: 0 } .card-group>.card:not(:last-child) { border-bottom-right-radius: 0; border-top-right-radius: 0 } .card-group>.card:not(:last-child) .card-header,.card-group>.card:not(:last-child) .card-img-top { border-top-right-radius: 0 } .card-group>.card:not(:last-child) .card-footer,.card-group>.card:not(:last-child) .card-img-bottom { border-bottom-right-radius: 0 } .card-group>.card:not(:first-child) { border-bottom-left-radius: 0; border-top-left-radius: 0 } .card-group>.card:not(:first-child) .card-header,.card-group>.card:not(:first-child) .card-img-top { border-top-left-radius: 0 } .card-group>.card:not(:first-child) .card-footer,.card-group>.card:not(:first-child) .card-img-bottom { border-bottom-left-radius: 0 } } .d-flex { display: flex!important; } .d-inline-flex { display: inline-flex!important } .d-none { display: none!important } .border { border: 1px solid #0003!important; border: var(--bs-border-width) var(--bs-border-style) #00000033 !important; } .border-0 { border: 0!important } .border-top { border-top: var(--bs-border-width) var(--bs-border-style) #00000033 !important; } .border-top-0 { border-top: 0!important } .border-end { border-right: 1px solid #0003!important; border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color)!important } .border-end-0 { border-right: 0!important } .border-bottom { border-bottom: 1px solid #0003!important; border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color)!important } .border-bottom-0 { border-bottom: 0!important } .border-start { border-left: 1px solid #0003!important; border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color)!important } .border-start-0 { border-left: 0!important } .border-default { --bs-border-opacity: 1; border-color: rgba(var(--bs-default-rgb),var(--bs-border-opacity))!important } .border-theme { --bs-border-opacity: 1; border-color: rgba(var(--bs-theme-rgb),var(--bs-border-opacity))!important } .border-theme-color { --bs-border-opacity: 1; border-color: rgba(var(--bs-theme-color-rgb),var(--bs-border-opacity))!important } .border-primary { --bs-border-opacity: 1; border-color: rgba(var(--bs-primary-rgb),var(--bs-border-opacity))!important } .border-secondary { --bs-border-opacity: 1; border-color: rgba(var(--bs-secondary-rgb),var(--bs-border-opacity))!important } .border-warning { --bs-border-opacity: 1; border-color: rgba(var(--bs-warning-rgb),var(--bs-border-opacity))!important } .border-danger { --bs-border-opacity: 1; border-color: rgba(var(--bs-danger-rgb),var(--bs-border-opacity))!important } .border-success { --bs-border-opacity: 1; border-color: rgba(var(--bs-success-rgb),var(--bs-border-opacity))!important } .border-inverse { --bs-border-opacity: 1; border-color: rgba(var(--bs-inverse-rgb),var(--bs-border-opacity))!important } .border-info { --bs-border-opacity: 1; border-color: rgba(var(--bs-info-rgb),var(--bs-border-opacity))!important } .border-dark { --bs-border-opacity: 1; border-color: rgba(var(--bs-dark-rgb),var(--bs-border-opacity))!important } .border-black { --bs-border-opacity: 1; border-color: rgba(var(--bs-black-rgb),var(--bs-border-opacity))!important } .border-white { --bs-border-opacity: 1; border-color: rgba(var(--bs-white-rgb),var(--bs-border-opacity))!important } .border-purple { --bs-border-opacity: 1; border-color: rgba(var(--bs-purple-rgb),var(--bs-border-opacity))!important } .border-indigo { --bs-border-opacity: 1; border-color: rgba(var(--bs-indigo-rgb),var(--bs-border-opacity))!important } .border-red { --bs-border-opacity: 1; border-color: rgba(var(--bs-red-rgb),var(--bs-border-opacity))!important } .border-pink { --bs-border-opacity: 1; border-color: rgba(var(--bs-pink-rgb),var(--bs-border-opacity))!important } .border-green { --bs-border-opacity: 1; border-color: rgba(var(--bs-green-rgb),var(--bs-border-opacity))!important } .border-yellow { --bs-border-opacity: 1; border-color: rgba(var(--bs-yellow-rgb),var(--bs-border-opacity))!important } .border-teal { --bs-border-opacity: 1; border-color: rgba(var(--bs-teal-rgb),var(--bs-border-opacity))!important } .border-muted { --bs-border-opacity: 1; border-color: rgba(var(--bs-muted-rgb),var(--bs-border-opacity))!important } .border-light { --bs-border-opacity: 1; border-color: rgba(var(--bs-light-rgb),var(--bs-border-opacity))!important } .border-lime { --bs-border-opacity: 1; border-color: rgba(var(--bs-lime-rgb),var(--bs-border-opacity))!important } .border-gray-100 { --bs-border-opacity: 1; border-color: rgba(var(--bs-gray-100-rgb),var(--bs-border-opacity))!important } .border-gray-200 { --bs-border-opacity: 1; border-color: rgba(var(--bs-gray-200-rgb),var(--bs-border-opacity))!important } .border-gray-300 { --bs-border-opacity: 1; border-color: rgba(var(--bs-gray-300-rgb),var(--bs-border-opacity))!important } .border-gray-400 { --bs-border-opacity: 1; border-color: rgba(var(--bs-gray-400-rgb),var(--bs-border-opacity))!important } .border-gray-500 { --bs-border-opacity: 1; border-color: rgba(var(--bs-gray-500-rgb),var(--bs-border-opacity))!important } .border-gray-600 { --bs-border-opacity: 1; border-color: rgba(var(--bs-gray-600-rgb),var(--bs-border-opacity))!important } .border-gray-700 { --bs-border-opacity: 1; border-color: rgba(var(--bs-gray-700-rgb),var(--bs-border-opacity))!important } .border-gray-800 { --bs-border-opacity: 1; border-color: rgba(var(--bs-gray-800-rgb),var(--bs-border-opacity))!important } .border-gray-900 { --bs-border-opacity: 1; border-color: rgba(var(--bs-gray-900-rgb),var(--bs-border-opacity))!important } .border-primary-subtle { border-color: #9ac6ff!important; border-color: var(--bs-primary-border-subtle)!important } .border-secondary-subtle { border-color: #a8b6bc!important; border-color: var(--bs-secondary-border-subtle)!important } .border-success-subtle { border-color: #a1d0a7!important; border-color: var(--bs-success-border-subtle)!important } .border-info-subtle { border-color: #99d7f4!important; border-color: var(--bs-info-border-subtle)!important } .border-warning-subtle { border-color: #fdf69e!important; border-color: var(--bs-warning-border-subtle)!important } .border-danger-subtle { border-color: #f39999!important; border-color: var(--bs-danger-border-subtle)!important } .border-light-subtle { border-color: #a8b6bc!important; border-color: var(--bs-light-border-subtle)!important } .border-dark-subtle { border-color: #617a86!important; border-color: var(--bs-dark-border-subtle)!important } .border-1 { border-width: 1px!important } .border-2 { border-width: 2px!important } .border-3 { border-width: 3px!important } .border-4 { border-width: 4px!important } .border-5 { border-width: 5px!important } .border-opacity-10 { --bs-border-opacity: 0.1 } .border-opacity-25 { --bs-border-opacity: 0.25 } .border-opacity-50 { --bs-border-opacity: 0.5 } .border-opacity-75 { --bs-border-opacity: 0.75 } .border-opacity-100 { --bs-border-opacity: 1 } .w-25 { width: 25%!important } .w-50 { width: 50%!important } .w-75 { width: 75%!important } .w-100 { width: 100%!important } .w-auto { width: auto!important } .mw-100 { max-width: 100%!important } .vw-100 { width: 100vw!important } .min-vw-100 { min-width: 100vw!important } .h-25 { height: 25%!important } .h-50 { height: 50%!important } .h-75 { height: 75%!important } .h-100 { height: 100%!important } .h-auto { height: auto!important } .mh-100 { max-height: 100%!important } .vh-100 { height: 100vh!important } .min-vh-100 { min-height: 100vh!important } .flex-fill { flex: 1 1 auto!important } .flex-row { flex-direction: row!important } .flex-column { flex-direction: column!important } .flex-row-reverse { flex-direction: row-reverse!important } .flex-column-reverse { flex-direction: column-reverse!important } .flex-grow-0 { flex-grow: 0!important } .flex-grow-1 { flex-grow: 1!important } .flex-shrink-0 { flex-shrink: 0!important } .flex-shrink-1 { flex-shrink: 1!important } .flex-wrap { flex-wrap: wrap!important } .flex-nowrap { flex-wrap: nowrap!important } .flex-wrap-reverse { flex-wrap: wrap-reverse!important } .justify-content-start { justify-content: flex-start!important } .justify-content-end { justify-content: flex-end!important } .justify-content-center { justify-content: center!important } .justify-content-between { justify-content: space-between!important } .justify-content-around { justify-content: space-around!important } .justify-content-evenly { justify-content: space-evenly!important } .align-items-start { align-items: flex-start!important } .align-items-end { align-items: flex-end!important } .align-items-center { align-items: center!important } .align-items-baseline { align-items: baseline!important } .align-items-stretch { align-items: stretch!important } .align-content-start { align-content: flex-start!important } .align-content-end { align-content: flex-end!important } .align-content-center { align-content: center!important } .align-content-between { align-content: space-between!important } .align-content-around { align-content: space-around!important } .align-content-stretch { align-content: stretch!important } .align-self-auto { align-self: auto!important } .align-self-start { align-self: flex-start!important } .align-self-end { align-self: flex-end!important } .align-self-center { align-self: center!important } .align-self-baseline { align-self: baseline!important } .align-self-stretch { align-self: stretch!important } .order-first { order: -1!important } .order-0 { order: 0!important } .order-1 { order: 1!important } .order-2 { order: 2!important } .order-3 { order: 3!important } .order-4 { order: 4!important } .order-5 { order: 5!important } .order-last { order: 6!important } .m-0 { margin: 0!important } .m-1 { margin: .25rem!important } .m-2 { margin: .5rem!important } .m-3 { margin: 1rem!important } .m-4 { margin: 1.5rem!important } .m-5 { margin: 3rem!important } .m-auto { margin: auto!important } .mx-0 { margin-left: 0!important; margin-right: 0!important } .mx-1 { margin-left: .25rem!important; margin-right: .25rem!important } .mx-2 { margin-left: .5rem!important; margin-right: .5rem!important } .mx-3 { margin-left: 1rem!important; margin-right: 1rem!important } .mx-4 { margin-left: 1.5rem!important; margin-right: 1.5rem!important } .mx-5 { margin-left: 3rem!important; margin-right: 3rem!important } .mx-auto { margin-left: auto!important; margin-right: auto!important } .my-0 { margin-bottom: 0!important; margin-top: 0!important } .my-1 { margin-bottom: .25rem!important; margin-top: .25rem!important } .my-2 { margin-bottom: .5rem!important; margin-top: .5rem!important } .my-3 { margin-bottom: 1rem!important; margin-top: 1rem!important } .my-4 { margin-bottom: 1.5rem!important; margin-top: 1.5rem!important } .my-5 { margin-bottom: 3rem!important; margin-top: 3rem!important } .my-auto { margin-bottom: auto!important; margin-top: auto!important } .mt-0 { margin-top: 0!important } .mt-1 { margin-top: .25rem!important } .mt-2 { margin-top: .5rem!important } .mt-3 { margin-top: 1rem!important } .mt-4 { margin-top: 1.5rem!important } .mt-5 { margin-top: 3rem!important } .mt-auto { margin-top: auto!important } .me-0 { margin-right: 0!important } .me-1 { margin-right: .25rem!important } .me-2 { margin-right: .5rem!important } .me-3 { margin-right: 1rem!important } .me-4 { margin-right: 1.5rem!important } .me-5 { margin-right: 3rem!important } .me-auto { margin-right: auto!important } .mb-0 { margin-bottom: 0!important } .mb-1 { margin-bottom: .25rem!important } .mb-2 { margin-bottom: .5rem!important } .mb-3 { margin-bottom: 1rem!important } .mb-4 { margin-bottom: 1.5rem!important } .mb-5 { margin-bottom: 3rem!important } .mb-auto { margin-bottom: auto!important } .ms-0 { margin-left: 0!important } .ms-1 { margin-left: .25rem!important } .ms-2 { margin-left: .5rem!important } .ms-3 { margin-left: 1rem!important } .ms-4 { margin-left: 1.5rem!important } .ms-5 { margin-left: 3rem!important } .ms-auto { margin-left: auto!important } .m-n1 { margin: -.25rem!important } .m-n2 { margin: -.5rem!important } .m-n3 { margin: -1rem!important } .m-n4 { margin: -1.5rem!important } .m-n5 { margin: -3rem!important } .mx-n1 { margin-left: -.25rem!important; margin-right: -.25rem!important } .mx-n2 { margin-left: -.5rem!important; margin-right: -.5rem!important } .mx-n3 { margin-left: -1rem!important; margin-right: -1rem!important } .mx-n4 { margin-left: -1.5rem!important; margin-right: -1.5rem!important } .mx-n5 { margin-left: -3rem!important; margin-right: -3rem!important } .my-n1 { margin-bottom: -.25rem!important; margin-top: -.25rem!important } .my-n2 { margin-bottom: -.5rem!important; margin-top: -.5rem!important } .my-n3 { margin-bottom: -1rem!important; margin-top: -1rem!important } .my-n4 { margin-bottom: -1.5rem!important; margin-top: -1.5rem!important } .my-n5 { margin-bottom: -3rem!important; margin-top: -3rem!important } .mt-n1 { margin-top: -.25rem!important } .mt-n2 { margin-top: -.5rem!important } .mt-n3 { margin-top: -1rem!important } .mt-n4 { margin-top: -1.5rem!important } .mt-n5 { margin-top: -3rem!important } .me-n1 { margin-right: -.25rem!important } .me-n2 { margin-right: -.5rem!important } .me-n3 { margin-right: -1rem!important } .me-n4 { margin-right: -1.5rem!important } .me-n5 { margin-right: -3rem!important } .mb-n1 { margin-bottom: -.25rem!important } .mb-n2 { margin-bottom: -.5rem!important } .mb-n3 { margin-bottom: -1rem!important } .mb-n4 { margin-bottom: -1.5rem!important } .mb-n5 { margin-bottom: -3rem!important } .ms-n1 { margin-left: -.25rem!important } .ms-n2 { margin-left: -.5rem!important } .ms-n3 { margin-left: -1rem!important } .ms-n4 { margin-left: -1.5rem!important } .ms-n5 { margin-left: -3rem!important } .p-0 { padding: 0!important } .p-1 { padding: .25rem!important } .p-2 { padding: .5rem!important } .p-3 { padding: 1rem!important } .p-4 { padding: 1.5rem!important } .p-5 { padding: 3rem!important } .px-0 { padding-left: 0!important; padding-right: 0!important } .px-1 { padding-left: .25rem!important; padding-right: .25rem!important } .px-2 { padding-left: .5rem!important; padding-right: .5rem!important } .px-3 { padding-left: 1rem!important; padding-right: 1rem!important } .px-4 { padding-left: 1.5rem!important; padding-right: 1.5rem!important } .px-5 { padding-left: 3rem!important; padding-right: 3rem!important } .py-0 { padding-bottom: 0!important; padding-top: 0!important } .py-1 { padding-bottom: .25rem!important; padding-top: .25rem!important } .py-2 { padding-bottom: .5rem!important; padding-top: .5rem!important } .py-3 { padding-bottom: 1rem!important; padding-top: 1rem!important } .py-4 { padding-bottom: 1.5rem!important; padding-top: 1.5rem!important } .py-5 { padding-bottom: 3rem!important; padding-top: 3rem!important } .pt-0 { padding-top: 0!important } .pt-1 { padding-top: .25rem!important } .pt-2 { padding-top: .5rem!important } .pt-3 { padding-top: 1rem!important } .pt-4 { padding-top: 1.5rem!important } .pt-5 { padding-top: 3rem!important } .pe-0 { padding-right: 0!important } .pe-1 { padding-right: .25rem!important } .pe-2 { padding-right: .5rem!important } .pe-3 { padding-right: 1rem!important } .pe-4 { padding-right: 1.5rem!important } .pe-5 { padding-right: 3rem!important } .pb-0 { padding-bottom: 0!important } .pb-1 { padding-bottom: .25rem!important } .pb-2 { padding-bottom: .5rem!important } .pb-3 { padding-bottom: 1rem!important } .pb-4 { padding-bottom: 1.5rem!important } .pb-5 { padding-bottom: 3rem!important } .ps-0 { padding-left: 0!important } .ps-1 { padding-left: .25rem!important } .ps-2 { padding-left: .5rem!important } .ps-3 { padding-left: 1rem!important } .ps-4 { padding-left: 1.5rem!important } .ps-5 { padding-left: 3rem!important } .gap-0 { gap: 0!important } .gap-1 { gap: .25rem!important } .gap-2 { gap: .5rem!important } .gap-3 { gap: 1rem!important } .gap-4 { gap: 1.5rem!important } .gap-5 { gap: 3rem!important } .row-gap-0 { row-gap: 0!important } .row-gap-1 { row-gap: .25rem!important } .row-gap-2 { row-gap: .5rem!important } .row-gap-3 { row-gap: 1rem!important } .row-gap-4 { row-gap: 1.5rem!important } .row-gap-5 { row-gap: 3rem!important } .flex-1 { flex: 1 1!important } .card-expand .app-content { height: calc(100vh - 3.25rem); overflow: hidden; position: relative; z-index: 1120 } .card { --bs-border-color-rgb: var(--bs-body-color-rgb); background: #ffffff0a; border: none; position: relative; max-width: 940px; width: 100%; margin: 24px auto; } .card.border-theme { --bs-border-color-rgb: var(--bs-theme-rgb) } .card.card-expand { background: #1d2835fa; border-radius: 0; bottom: 0; height: auto!important; left: 0; margin: 0!important; padding: .3125rem; position: fixed; right: 0; top: 0; z-index: 1120 } .card.card-expand .card-body,.card.card-expand .card-header { border-radius: 0 } .card.card-expand .card-body { flex: 1 0; height: auto!important; overflow: scroll } .card.card-expand:not(.border-0):before { bottom: 5px; left: 20px; right: 20px; top: 5px } .card.card-expand:not(.border-0):after { bottom: 20px; left: 5px; right: 5px; top: 20px } .card.card-expand .card-arrow { margin: 5px } .card .card-header .card-header-tabs .nav-item .nav-link.active { border-bottom-color: #0000 } .card .card-body .nav-tabs .nav-item .nav-link.active { background: var(--bs-card-bg); border-bottom-color: var(--bs-card-bg) } .card:after,.card:before { content: ""; position: absolute } .card:not(.border-0):before { } .card:not(.border-0):after { } .card>:not(.card-arrow):not(.card-img-overlay):not(.card-img):not(.hljs-container) { position: relative; z-index: 10 } .card .card-arrow {display: none;} .card .card-arrow-bottom-left,.card .card-arrow-bottom-right,.card .card-arrow-top-left,.card .card-arrow-top-right { height: 10px; position: absolute; width: 10px } .card .card-arrow-bottom-left:before,.card .card-arrow-bottom-right:before,.card .card-arrow-top-left:before,.card .card-arrow-top-right:before { background: rgb(0 0 0 / 75%); content: ""; height: 8px; position: absolute; width: 2px } .card .card-arrow-bottom-left:after,.card .card-arrow-bottom-right:after,.card .card-arrow-top-left:after,.card .card-arrow-top-right:after { background: rgb(0 0 0 / 75%); content: ""; height: 2px; position: absolute; width: 10px } .card .card-arrow-top-left,.card .card-arrow-top-right { top: 0 } .card .card-arrow-top-left:before,.card .card-arrow-top-right:before { top: 2px } .card .card-arrow-top-left:after,.card .card-arrow-top-right:after { top: 0 } .card .card-arrow-bottom-left,.card .card-arrow-bottom-right { bottom: 0 } .card .card-arrow-bottom-left:before,.card .card-arrow-bottom-right:before { bottom: 2px } .card .card-arrow-bottom-left:after,.card .card-arrow-bottom-right:after { bottom: 0 } .card .card-arrow-bottom-left,.card .card-arrow-bottom-left:after,.card .card-arrow-bottom-left:before,.card .card-arrow-top-left,.card .card-arrow-top-left:after,.card .card-arrow-top-left:before { left: 0 } .card .card-arrow-bottom-right,.card .card-arrow-bottom-right:after,.card .card-arrow-bottom-right:before,.card .card-arrow-top-right,.card .card-arrow-top-right:after,.card .card-arrow-top-right:before { right: 0 } .px-3.py-2.mt-3 { border: 1px solid #00000033 !important;!i;!; } .progress.flex-1 { display: none; } span.d-block { display: block; }
              .d-flex.flex-wrap.gap-3.image-row {float: left;overflow: hidden;} .d-flex.flex-wrap.gap-3.image-row a { height: 210px; display: block; overflow: hidden; } .d-flex.flex-wrap.gap-3.image-row a im {} .d-flex.flex-wrap.gap-3.image-row a img { width: 100%; height: 100% !important;!i;!; object-fit: contain; } .mt-3.position-relative { overflow: hidden; }
              </style>
            </head>
            <body>${printContent.innerHTML}</body>
          </html>
        `
          );
          printWindow.document.close();
          printWindow.focus();

          setTimeout(() => {
            printWindow.print();
          }, 1000);
        }
      }
    }
  };

  return (
    <div className="row mb-5 pb-5 g-4">
      {reportItem?.todo ? (
        <div>
          <div className="d-flex flex-wrap gap-2">
            <button
              type="button"
              className="btn btn-outline-theme mb-3"
              onClick={() => setReportItem({ group: null }, { todo: null })}
            >
              {context?.t?.go_back}
            </button>

            <button
              type="button"
              className="btn btn-outline-theme mb-3"
              onClick={() => handlePrint()}
            >
              {context?.t?.rapor}
            </button>
          </div>
          <div ref={printRef}>
            {TaskItem(reportItem?.group, reportItem?.todo, true)}
          </div>
        </div>
      ) : (
        <>
          {groupedTodos ? (
            groupedTodos.length !== 0 ? (
              <div className="col-12">
                <div className="row g-4">
                  {/* Category Filter Sidebar */}
                  <div className="col" style={{ flex: "0 0 200px" }}>
                    <div className="border p-3 h-100">
                      <div
                        className="d-flex flex-column gap-2 position-sticky"
                        style={{ top: 15 }}
                      >
                        {/* <button
                      className={`btn w-100 px-1 btn-white`}
                      onClick={() => handleExportPDF()}
                    >
                      PDF
                    </button>

                    <hr className="my-1" /> */}

                        <button
                          className={`btn w-100 px-1 btn${
                            selectedCategory === "TÜMÜ" ? "" : "-outline"
                          }-theme`}
                          onClick={() => handleCategoryClick("TÜMÜ")}
                        >
                          {context?.t?.all}
                        </button>

                        {groupedTodos.map((group, index) => (
                          <div
                            key={index}
                            className={`btn w-100 px-1 btn${
                              selectedCategory === group?.category?.name
                                ? ""
                                : "-outline"
                            }-theme`}
                            onClick={() =>
                              handleCategoryClick(group?.category?.name)
                            }
                          >
                            {group?.category?.name} ({group?.list.length})
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Content Display */}
                  <div className="col overflow-hidden">
                    {dataView && (
                      <iframe
                        title="pdfViewer"
                        src={dataView}
                        width="100%"
                        style={{ height: "calc(100vh - 330px)" }}
                      />
                    )}

                    <div className="row g-4">
                      {selectedCategory === "TÜMÜ"
                        ? /* Display All Categories with Swiper */
                          filteredTodos.map((group, index) => (
                            <div className="col-12" key={group?.category?.id}>
                              <div className="border p-3">
                                <div className="mb-4 d-flex gap-2 align-items-center flex-wrap border-bottom pb-3">
                                  <h4 className="mb-0">
                                    {group?.category?.name} (
                                    {group?.list.length})
                                  </h4>

                                  <div className="d-flex gap-2 border-start ps-2">
                                    <button
                                      className="btn btn-outline-theme"
                                      onClick={() =>
                                        todoSwipers[
                                          group?.category?.id
                                        ]?.slidePrev()
                                      }
                                    >
                                      {context?.t?.prev}
                                    </button>
                                    <button
                                      className="btn btn-outline-theme"
                                      onClick={() =>
                                        todoSwipers[
                                          group?.category?.id
                                        ]?.slideNext()
                                      }
                                    >
                                      {context?.t?.next}
                                    </button>
                                  </div>
                                </div>

                                <Swiper
                                  onSwiper={(s) => {
                                    setTodoSwipers((prevSwipers) => ({
                                      ...prevSwipers,
                                      [group?.category?.id]: s,
                                    }));
                                  }}
                                  //   autoplay={{
                                  //     delay: 3000,
                                  //     disableOnInteraction: false,
                                  //   }}
                                  slidesPerView={1}
                                  spaceBetween={20}
                                  //   modules={[Autoplay]}
                                  breakpoints={{
                                    1500: {
                                      slidesPerView: 4,
                                    },
                                    1199: {
                                      slidesPerView: 3,
                                    },
                                    768: {
                                      slidesPerView: 2,
                                    },
                                  }}
                                >
                                  {group.list.map((todo) => (
                                    <SwiperSlide key={todo.id}>
                                      {TaskItem(group, todo)}
                                    </SwiperSlide>
                                  ))}
                                </Swiper>
                              </div>
                            </div>
                          ))
                        : /* Display Only Selected Category without Swiper */
                          filteredTodos.map((group, groupIndex) => (
                            <div className="col-12" key={groupIndex}>
                              <div className="border p-3">
                                <div className="mb-4 d-flex gap-2 align-items-center flex-wrap border-bottom pb-3">
                                  <h4 className="mb-0">
                                    {group?.category?.name} (
                                    {group?.list.length})
                                  </h4>
                                </div>

                                <div className="row g-4">
                                  {group.list.map((todo) => (
                                    <div
                                      className="col-12 col-md-6 col-lg-3"
                                      key={todo.id}
                                    >
                                      {TaskItem(group, todo)}
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          ))}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="col-12">{context?.t?.gorev_mevcut_degil}</div>
            )
          ) : (
            <div className="col-12">
              <div className="spinner-border spinner-border-sm text-theme"></div>
            </div>
          )}
        </>
      )}

      <div className="modal modal-cover fade" id="taskDescriptionModal">
        <div className="modal-dialog py-4" style={{ maxWidth: 1000 }}>
          <div
            className="modal-content rounded"
            style={{ background: "var(--bs-dark4)" }}
          >
            <div className="modal-header">
              <h3 className="modal-title">{context?.t?.description}</h3>

              <button
                type="button"
                className="btn-close"
                id="taskDescriptionModalCloseButton"
                data-bs-dismiss="modal"
                onClick={() => setShowDescription(null)}
              ></button>
            </div>

            <div className="modal-body">
              {showDescription && (
                <div
                  className="text-white mb-0 overflow-auto"
                  dangerouslySetInnerHTML={{
                    __html: showDescription,
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
